import { type UseQueryResult, useQuery } from 'react-query';
import {
  TwoFactorPurposeService,
  type Wealthlane_Dtos_TwoFactor_TwoFactorPurposeDto,
} from '../../services/wealthlane-identity-services';

const useGetTwoFactorPurposes = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<Array<Wealthlane_Dtos_TwoFactor_TwoFactorPurposeDto> | undefined, unknown> => {
  return useQuery(['getTwoFactorPurposes'], async () => {
    return await handleRequest(
      TwoFactorPurposeService.getApiIdentityApiAppTwoFactorPurpose()
    );
  });
};

export default useGetTwoFactorPurposes;
